import React from 'react';
import PropTypes from 'prop-types';
import RCTooltip from 'rc-tooltip';
import './styles.scss';

const Tooltip = props => <RCTooltip {...props} />;

Tooltip.propTypes = {
  placement: PropTypes.string,
};

Tooltip.defaultProps = {
  placement: 'top',
};

export default Tooltip;
